import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button, Input, Field } from "@/components/ds";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@locofast.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (ready && user) nav("/admin"); }, [ready, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      nav("/admin");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--lf-blue-900)", backgroundImage: "var(--texture-weave-light)", padding: 24 }}>
      <form onSubmit={submit} className="lf-fade-up" style={{ width: "100%", maxWidth: 400, background: "var(--surface-card)", borderRadius: "var(--radius-xl)", boxShadow: "var(--shadow-floating)", padding: 32, display: "flex", flexDirection: "column", gap: 18 }}>
        <div>
          <img src="/locofast-logo.png" alt="Locofast" style={{ height: 28, marginBottom: 16 }} />
          <div style={{ font: "var(--fw-semibold) 24px/1.2 var(--font-display)", color: "var(--text-primary)" }}>Admin sign in</div>
          <div style={{ marginTop: 6, font: "var(--fw-regular) 13px/1.4 var(--font-sans)", color: "var(--text-secondary)" }}>Manage the denim catalogue and buyer enquiries.</div>
        </div>
        <Field label="Email"><Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@locofast.com" /></Field>
        <Field label="Password"><Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" /></Field>
        <Button data-testid="login-submit" type="submit" variant="primary" size="md" fullWidth disabled={busy}>{busy ? "Signing in…" : "Sign in"}</Button>
      </form>
    </div>
  );
}
